import React from 'react';

export default function WalletIcon({ active = false, size = 34, ...props }) {
  const strokeColor = active ? '#F5D000' : 'rgba(255,255,255,0.55)';
  const lineColor = active ? 'rgba(245,208,0,0.5)' : 'rgba(255,255,255,0.4)';
  const topLineColor = active ? 'rgba(245,208,0,0.3)' : 'rgba(255,255,255,0.25)';
  const cardColor = active ? '#F5D000' : 'rgba(255,255,255,0.4)';

  return (
    <svg
      width={size}
      height={size}
      viewBox="1 3 20 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="3"
        y="6"
        width="16"
        height="12"
        rx="2"
        stroke={strokeColor}
        strokeWidth="1.8"
      />
      <path
        d="M3 9H19"
        stroke={lineColor}
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M6 4.5H16"
        stroke={topLineColor}
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <rect
        x="14"
        y="11.5"
        width="3.5"
        height="3"
        rx="1"
        fill={cardColor}
        stroke="none"
      />
    </svg>
  );
}
